import { Field } from 'types'

import { createField, withGroupByPlaceholder } from './createField'
import { FieldCreatorOptions } from './localTypes'

export function placementText<RecordType>(
    options: FieldCreatorOptions<RecordType> = {}
): Field<RecordType> {
    const key = 'placement'
    const displayName = 'Campaign Placement'
    return withGroupByPlaceholder(
        createField({
            ...options,
            id: key,
            name: displayName,
            shortName: displayName,
            minWidth: 70,
            dataIndex: options.dataIndex ?? [key],
            width: 200,
            sorter: options.sorter ?? false,
        }),
        {
            id: key,
            slug: 'campaign-placement',
            displayName,
            definition:
                'Displays the placement of advertisements within a campaign.',
            supportsTotal: true,
        }
    )
}

export function placementMultiplier<RecordType>(
    options: FieldCreatorOptions<RecordType> = {}
): Field<RecordType> {
    const dataIndex = options.dataIndex ?? ['multiplier']
    return createField({
        ...options,
        id: 'placement_multiplier',
        name: 'Placement Multiplier',
        shortName: 'Placement Multiplier',
        minWidth: 50,
        dataIndex,
        width: 100,
        sorter: options.sorter ?? false,
    })
}
